export const parseJSON = (jsonString: string) => {
  try {
    const parsedJSON = JSON.parse(jsonString);
    return parsedJSON;
  } catch (e) {
    return {};
  }
};
